<ca-modal-container [modalTitle]="'LOG_VIEW.TITLE' | translate" (dismiss)="dismiss($event)">
    <div class="d-flex w-100 py-0 button-container">
        <button
            (cbOnSuccess)="t.open()"
            [cbContent]="log"
            [disabled]="!log"
            [ngbTooltip]="'LOG_VIEW.COPIED_LOGS' | translate"
            [title]="'LOG_VIEW.COPY_LOGS' | translate"
            #t="ngbTooltip"
            placement="body"
            class="btn ca-btn-icon"
            data-uit="log-copy-logs-button"
            ngxClipboard
            triggers="manual"
            type="button"
        >
            <ca-icon name="copy" size="s"></ca-icon>
        </button>
        <button
            (click)="downloadLogs()"
            [disabled]="!log"
            [title]="'LOG_VIEW.DOWNLOAD_LOGS' | translate"
            class="btn ca-btn-icon"
            data-uit="log-download-logs-button"
            type="button"
        >
            <ca-icon name="download" size="s"></ca-icon>
        </button>
    </div>
    <div class="pt-4 pb2 w-100">
        <div *ngIf="!log && !isLoading" class="no-logs-available">
            {{ 'LOG_VIEW.NO_LOG_AVAILABLE' | translate }}
        </div>
        <div *ngIf="!log && isLoading" class="loading-logs">
            {{ 'LOG_VIEW.LOADING' | translate }}
        </div>
        <ca-logs *ngIf="log" [logData]="{ log, logName, maxLineLength }"></ca-logs>
    </div>
</ca-modal-container>
